import React from 'react';
import styles from './SupportCasesPanel.module.css';

interface SupportCasesPanelProps {
  needsAttention: number;
  inProgress: number;
  notStarted: number;
}

export const SupportCasesPanel: React.FC<SupportCasesPanelProps> = ({
  needsAttention,
  inProgress,
  notStarted,
}) => {
  return (
    <div className={styles.supportCasesPanel}>
      <h3 className={styles.title}>Support Cases</h3>
      <div className={styles.content}>
        <div className={styles.statItem}>
          <span className={styles.statValue}>{needsAttention}</span>
          <span className={styles.statLabel}>Needs attention</span>
        </div>
        <div className={styles.statItem}>
          <span className={styles.statValue}>{inProgress}</span>
          <span className={styles.statLabel}>In-progress</span>
        </div>
        <div className={styles.statItem}>
          <span className={styles.statValue}>{notStarted}</span>
          <span className={styles.statLabel}>Not-started</span>
        </div>
      </div>
    </div>
  );
};
